define.alias("ember-math-helpers/helpers/floor", "media/helpers/floor");